export enum MarketAppVisibility {
    DASHBOARD_ZONE = 'DASHBOARD_ZONE',
    DASHBOARD_LOCATION = 'DASHBOARD_LOCATION',
}

export class MarketAppView {
    constructor(readonly id: number, readonly key: string, readonly title: string) {}
}
